import { render, staticRenderFns } from "./MaterialDevDetail.vue?vue&type=template&id=d74c0f46&"
import script from "./MaterialDevDetail.vue?vue&type=script&lang=js&"
export * from "./MaterialDevDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports